// Action Types for Redux
export const ActionTypes = {
  SET_APP_DATA: "SET_APP_DATA",
  SHOW_MODAL: "SHOW_MODAL",
  HIDE_MODAL: "HIDE_MODAL",
  SET_AUTH_VARIANT: "SET_AUTH_VARIANT",
  SHOW_SIGNUP_MODAL: "SHOW_SIGNUP_MODAL",
  SHOW_MENTOR_SIGNUP_MODAL: "SHOW_MENTOR_SIGNUP_MODAL",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_FORM_DATA: "SET_FORM_DATA",
  SET_IS_FETCHING: "SET_IS_FETCHING",
  SET_ERROR: "SET_ERROR",
  GET_API_REQUEST: "GET_API_REQUEST",
  SET_USER_EMAIL: "SET_USER_EMAIL",
  SET_DASHBOARD: "SET_DASHBOARD",
  RESET_USER_EMAIL: "RESET_USER_EMAIL",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_AVATAR: "UPDATE_AVATAR",
  SET_USER_TYPE: "SET_USER_TYPE",
  GET_SINGLE_MENTOR_SUCCESS: "GET_SINGLE_MENTOR_SUCCESS",
  GET_SINGLE_MENTOR_ERROR: "GET_SINGLE_MENTOR_ERROR",
  FETCH_UPCOMING_SESSIONS_SUCCESS: "FETCH_UPCOMING_SESSIONS_SUCCESS",
  FETCH_UPCOMING_SESSIONS_ERROR: "FETCH_UPCOMING_SESSIONS_ERROR",
  FETCH_PAST_SESSIONS_SUCCESS: "FETCH_PAST_SESSIONS_SUCCESS",
  FETCH_PAST_SESSIONS_ERROR: "FETCH_PAST_SESSIONS_ERROR",
  SET_USER_BOOKINGS: "SET_USER_BOOKINGS",
  BOOKINGS_LOADING: "BOOKINGS_LOADING",
  BOOKINGS_ERROR: "BOOKINGS_ERROR",
  SUBMIT_REVIEW_START: "SUBMIT_REVIEW_START",
  SUBMIT_REVIEW_SUCCESS: "SUBMIT_REVIEW_SUCCESS",
  SUBMIT_REVIEW_ERROR: "SUBMIT_REVIEW_ERROR",
  SET_EVENT_REMINDER_START: "SET_EVENT_REMINDER_START",
  SET_EVENT_REMINDER_SUCCESS: "SET_EVENT_REMINDER_SUCCESS",
  SET_EVENT_REMINDER_ERROR: "SET_EVENT_REMINDER_ERROR",
  FETCH_REFERRALS_SUCCESS: "FETCH_REFERRALS_SUCCESS",
  FETCH_COURSE_REVIEWS_START: "FETCH_COURSE_REVIEWS_START",
  FETCH_COURSE_REVIEWS_SUCCESS: "FETCH_COURSE_REVIEWS_SUCCESS",
  FETCH_COURSE_REVIEWS_ERROR: "FETCH_COURSE_REVIEWS_ERROR",
  SUBMIT_COURSE_REVIEW_START: "SUBMIT_COURSE_REVIEW_START",
  SUBMIT_COURSE_REVIEW_SUCCESS: "SUBMIT_COURSE_REVIEW_SUCCESS",
  SUBMIT_COURSE_REVIEW_ERROR: "SUBMIT_COURSE_REVIEW_ERROR",
  // UNIFIED ACCOUNT: Experiences state
  FETCH_EXPERIENCES_START: "FETCH_EXPERIENCES_START",
  FETCH_EXPERIENCES_SUCCESS: "FETCH_EXPERIENCES_SUCCESS",
  FETCH_EXPERIENCES_ERROR: "FETCH_EXPERIENCES_ERROR",
};
